import * as React from 'react'
import { ReviewCard } from 'components/molecules/ReviewCard'
import styled from 'styled-components'
import * as interfaces from 'static/interfaces'
import { utilService } from 'core/services'
import { COLORS, BREAKPOINT_DESKTOP, BREAKPOINT_TABLET_MOBILE } from 'static/constants'

interface IProps {
  reviews: interfaces.IReview[]
}

export const Reviews: React.FC<IProps> = props => {
  const { data: reviews } = utilService.getDataFromJson(props.reviews)

  return (
    <Wrapper>
      {reviews.map(review => (
        <div className="review" key={review.id}>
          <ReviewCard review={{ ...review, reviewable: null }} singleStretch={true} />
          <div className="experience">
            <div className="title">Experience</div>
            <div className="name">
              <a href={`/posts/${review.reviewable.family_owner_slug || review.reviewable.slug}`}>
                {review.reviewable.name}
              </a>
            </div>
          </div>
        </div>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2.4rem 1.6rem;
  .review {
    display: flex;
    flex-direction: column;
    width: calc(25% - 1.2rem);
    gap: 1.2rem;
    flex: 0 0 auto;
    min-width: 0;
    @media (max-width: ${BREAKPOINT_DESKTOP}px) {
      width: calc(50% - 0.8rem);
    }
    @media (max-width: ${BREAKPOINT_TABLET_MOBILE}px) {
      width: 100%;
    }
    .experience {
      .title {
        color: ${COLORS.subText};
        font-size: 12px;
        font-weight: 700;
      }
      .name {
        color: ${COLORS.black};
        font-size: 14px;
        width: 100%;
        a {
          display: block;
          color: inherit;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-decoration: underline;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
`

export default Reviews
